export enum UTMParameters {
  Source = 'utm_source',
  Medium = 'utm_medium',
  Campaign = 'utm_campaign',
  Term = 'utm_term',
  Content = 'utm_content',
};
